import './BTSSectionComponent.css';

const BTSSectionComponent = () => {
    return <div className='bts-viewport grid-parent bts-layout'>
        <span className="behind-the-span">
            <span className="inline-bold">BEHIND</span> <span className="yellow">THE</span> <span className="inline-bold">SCENES</span> <br/>
            <span className="inline-bold">COORDINATES</span> <span className="yellow">THE</span> <span className="inline-bold">NETWORK</span>
        </span>

        <span className="copywrite-span">© 2026 Pixay. All rights reserved.</span>
    </div>
}

export default BTSSectionComponent;